module.exports = __webpack_public_path__ + "static/media/cli.d0a4d461.png";